<template>

  <v-dialog class="dialog" v-model="dialog" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ text }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed="depressed" @click="dialog = false">No</v-btn>
        <v-btn depressed="depressed" @click="confirmed()">Yes</v-btn>
      </v-card-actions>
    </v-card>
    <v-icon class="mr-2" title="Suspend" slot="activator">mdi-flag</v-icon>
  </v-dialog>

</template>

<script>

export default {
  name: 'ProxySuspendButton',
  props: ['text'],
  data: () => ({
    dialog: null
  }),
  methods: {
    confirmed () {
      this.$emit('click')
      this.dialog = false
    }
  }
}

</script>

<style lang="scss" scoped>

  .dialog {
    margin-top: -7px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/ProxySuspendButton.vue